// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600&family=Poppins:wght@100;200;300;400;500;600&family=Roboto:wght@100;300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
	scroll-behavior: smooth;
	scroll-padding-top: var(--scroll-padding, 50px);
}

body {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	overflow: hidden;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar,
.design-scrollbar::-webkit-scrollbar,
.facebook-share-window .ck.ck-content::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}
.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar-track,
.design-scrollbar::-webkit-scrollbar-track,
.facebook-share-window .ck.ck-content::-webkit-scrollbar-track {
	background-color: #fff;
	border-radius: 50px;
	margin-block: 10px;
}
.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar-thumb,
.design-scrollbar::-webkit-scrollbar-thumb,
.facebook-share-window .ck.ck-content::-webkit-scrollbar-thumb {
	background-color: #1CBAA7;
	border-radius: 50px;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
	color: #fff !important;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover:before,
.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item:before {
	content: "\\f111";
	font-family: "Font Awesome 6 Free";
	font-weight: 900;
	color: #1CBAA7;
	position: absolute;
	left: -8px;
	text-shadow: 5px 0px 15px rgba(150, 197, 66, 1);
	background-color: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
	color: #fff !important;
	position: relative;
}
.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item > .pro-icon-wrapper .pro-icon svg {
	fill: #fff !important;
	color: #fff !important;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover > .pro-icon-wrapper .pro-icon svg {
	color: #fff !important;
	fill: #fff !important;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
	background-color: transparent !important;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
	padding: 0 !important;
}

.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-menu-item .pro-inner-item:hover:before,
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-menu-item.active .pro-inner-item:before {
	content: "";
	display: none !important;
}
#search-dropdown div input:focus {
	box-shadow: none !important;
}
input:focus,
select:focus,
textarea:focus {
	border-color: #1CBAA7 !important;
	box-shadow: 0 0 0 1px #1CBAA7 !important;
}
input,
select,
textarea {
	color: #606060 !important;
}
.animate_notification_bell {
	animation: notification_bell_animation 2s normal;
	animation-delay: 2s;
	animation-iteration-count: 3;
	animation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);
}
@keyframes notification_bell_animation {
	0%,
	30%,
	50%,
	70%,
	100% {
		transform: rotate(0deg);
	}
	10% {
		transform: rotate(10deg);
	}
	40% {
		transform: rotate(-10deg);
	}
	60% {
		transform: rotate(5deg);
	}
	80% {
		transform: rotate(-5deg);
	}
}
.clear-date-btn::after {
	content: "\\f057" !important;
	font-size: 1rem !important;
	font-family: "Font Awesome 6 Free";
	font-weight: 900;
	color: #1CBAA7 !important;
	background-color: transparent !important;
}
.react-datepicker {
	font-family: inherit !important;
	border: none !important;
	box-shadow: 0px 5px 15px 10px rgba(187, 193, 200, 0.25);
}
.react-datepicker .react-datepicker__header {
	background-color: #1CBAA7;
	color: #093653 !important;
	padding: 15px 0px 5px 0px;
}
.react-datepicker .react-datepicker__triangle {
	border: none !important;
}
.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
	margin: 25px 0 15px 0;
}
.react-datepicker__navigation--next,
.react-datepicker__navigation--previous {
	top: 15px !important;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
	border-color: #093653 !important;
}
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before {
	border-top-color: #fff !important;
}
.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
	color: #fff !important;
	background-color: #1CBAA7 !important;
	border-radius: 0.3rem;
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
	background-color: #999999 !important;
}
.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
	background-color: #093653 !important;
}
.react-datepicker__header__dropdown,
.react-datepicker__header__dropdown--scroll {
	display: flex;
	justify-content: space-evenly;
}

.ql-toolbar.ql-snow {
	background-color: #1CBAA7;
	color: #fff;
	border-color: transparent !important;
	border-radius: 10px 10px 0 0;
	font-family: inherit !important;
}
.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
	color: #093653 !important;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
	color: #093653 !important;
}
.ql-container.ql-snow {
	border-color: #c6c6c6 !important;
	border-radius: 0 0 10px 10px;
	overflow: auto;
	width: 100% !important;
}
.ck.ck-toolbar {
	background: transparent !important;
	border-top-right-radius: 6px !important;
	border-top-left-radius: 6px !important;
	border-bottom-right-radius: 0px !important;
	border-bottom-left-radius: 0px !important;
	border: 1px solid rgba(30, 30, 30, 0.3) !important;
	width: 100% !important;
}
.ck.ck-content {
	background: #ffffff !important;
	color: #093653 !important;
	border: 1px solid rgba(30, 30, 30, 0.3) !important;
	border-top: none !important;
	border-top-right-radius: 0px !important;
	border-top-left-radius: 0px !important;
	border-bottom-right-radius: 6px !important;
	border-bottom-left-radius: 6px !important;
	margin-top: 0 !important;
	transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
	padding-left: 2rem !important;
	padding-right: 2rem !important;
}
.ck.ck-content:hover {
	border-color: 1px solid rgba(30, 30, 30, 0.3) !important;
}
.ck.ck-content:focus {
	outline: 0 none !important;
	outline-offset: 0 !important;
	box-shadow: 0 0 0 0rem #093653 !important;
	border-color: 1px solid rgba(30, 30, 30, 0.3) !important;
}

.ck.ck-reset_all,
.ck.ck-reset_all * {
	font-family: inherit !important;
}
.ck.ck-editor__editable_inline {
	box-shadow: none !important;
}

.facebook-share-window .ck.ck-content {
	height: 240px !important;
}
@media (min-width: 1559px) {
	.facebook-share-window .ck.ck-content {
		height: 275px !important;
	}
}
button.custom-btn {
	text-transform: uppercase !important;
	font-weight: 400 !important;
	letter-spacing: 0.5px !important;
}
input.custom-input {
	color: #000 !important;
	border-color: rgba(30, 30, 30, 0.3) !important;
}

input.custom-phone-input {
	color: #000 !important;
	border-color: rgba(30, 30, 30, 0.3) !important;
	background-color: #fff !important;
}

.swiper {
	width: 100%;
	height: 100%;
}

.swiper-slide {
	text-align: center;

	/* Center slide text vertically */
	display: flex;
	justify-content: center;
	align-items: stretch;
}
.swiper-slide img {
	display: block;
	width: 100%;
	/* height: 100%; */
	object-fit: contain;
}

.swiper-pagination-bullet {
	width: 12px !important;
	height: 12px !important;
	text-align: center;
	opacity: 1 !important;
	background: #fff !important;
	background: rgba(107, 168, 2, 0.25) !important;
	border: 1px solid rgba(149, 197, 66, 1);
}

.swiper-pagination-bullet-active {
	color: #fff;
	border: 1px solid #1CBAA7 !important;
	background: #1CBAA7 !important;
}
.swiper-button-next,
.swiper-button-prev {
	bottom: 0 !important;
	top: 95% !important;
	height: 30px !important;
	width: 30px !important;
	padding: 5px !important;
}
.swiper-button-next {
	background-color: #1CBAA7 !important;
}
.swiper-button-prev {
	background-color: #fff !important;
}
.swiper-button-prev,
.swiper-rtl .swiper-button-next {
	/* right: 53% !important; */
	right: 13% !important;
	left: unset !important;
}
.swiper-button-next,
.swiper-rtl .swiper-button-prev {
	/* right: 47% !important; */
	right: 5% !important;
	left: unset !important;
}
.swiper-button-prev:after {
	content: "\\f060" !important;
	font-size: 1rem !important;
	font-family: "Font Awesome 6 Free" !important;
	font-weight: 900;
	color: #1CBAA7 !important;
}
.swiper-button-next:after {
	content: "\\f061" !important;
	font-size: 1rem !important;
	font-family: "Font Awesome 6 Free" !important;
	font-weight: 900;
	color: #fff !important;
}
/* .swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled {
	display: none !important;
} */
.donation-level .hover-btn,
.rt-tbody .rt-tr-group .hover-btn {
	opacity: 0;
	transition: all 0.15s ease-out;
}
.donation-level:hover .hover-btn,
.rt-tbody .rt-tr-group:hover .hover-btn {
	opacity: 1;
	visibility: visible;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
}

input[type="color"] {
	width: 48px;
	height: 48px;
	border: none;
	border-radius: 50%;
	background: none;
}
input[type="color"]::-webkit-color-swatch-wrapper {
	padding: 0;
}
input[type="color"]::-webkit-color-swatch {
	border: none; /*change color of the swatch border here*/
	border-radius: 50%;
	cursor: pointer;
}
.filter-dropdown {
	width: 300px;
	min-width: 250px;
	background-color: #fff;
	border: none;
	border-radius: 5px;
	box-shadow: 0px 5px 15px 10px rgba(187, 193, 200, 0.1);
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
	white-space: pre-wrap !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
	padding-left: 50px !important;
}
input::placeholder {
	font-size: 16px !important;
}
.react-datepicker-popper {
	z-index: 10 !important;
}
.error-msg {
	color: #df5151 !important;
}
.custom-toast {
	font-family: "Roboto", sans-serif;
	letter-spacing: 0.5px;
	font-weight: 400;
}
.toast-glass-effect {
	backdrop-filter: blur(15px);
	-webkit-backdrop-filter: blur(15px);
	/* border-radius: 10px; */
}
/* .Toastify__toast-theme--colored.Toastify__toast--default {
	background: rgba(255, 255, 255, 0.45) !important;
	box-shadow: 0 8px 32px 0 rgba(255, 255, 255, 0.15);
	border: 1px solid rgba(255, 255, 255, 0.25);
 } */
.Toastify__toast-theme--colored.Toastify__toast--info {
	background: rgba(190, 227, 248, 0.5) !important;
	box-shadow: 0 8px 32px 0 rgba(190, 227, 248, 0.15);
	/* border: 1px solid rgba(190, 227, 248, 0.25); */
}
.Toastify__toast-theme--colored.Toastify__toast--success {
	background: #1CBAA7 !important;
	box-shadow: 0 8px 32px 0 rgba(150, 197, 66, 0.15);
	/* border: 1px solid rgba(150, 197, 66, 0.25); */
}
.Toastify__toast-theme--colored.Toastify__toast--warning {
	background: rgba(241, 196, 15, 0.5) !important;
	/* box-shadow: 0 8px 32px 0 rgba(241, 196, 15, 0.15); */
	/* border: 1px solid rgba(241, 196, 15, 0.25); */
}
.Toastify__toast-theme--colored.Toastify__toast--error {
	background: rgba(221, 57, 57, 0.5) !important;
	box-shadow: 0 8px 32px 0 rgba(221, 57, 57, 0.15);
	/* border: 1px solid rgba(221, 57, 57, 0.25); */
}
.react-datepicker__navigation--years {
	background: none !important;
	line-height: 1.7rem !important;
	text-align: center !important;
	cursor: pointer !important;
	padding: 0 !important;
	border: 0.45rem solid transparent !important;
	z-index: 1 !important;
	height: 10px !important;
	width: 10px !important;
	text-indent: -999em !important;
	overflow: hidden !important;
	position: relative !important;
	display: block !important;
	margin-left: auto !important;
	margin-right: auto !important;
}

.react-datepicker__navigation--years.react-datepicker__navigation--years-upcoming {
	top: -2px !important;
	border-bottom-color: #093653 !important;
}

.react-datepicker__navigation--years.react-datepicker__navigation--years-previous {
	top: 8px !important;
	border-top-color: #093653 !important;
}
.react-datepicker__year-option {
	height: 20px !important;
}
.text-overflow {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;CACC,uBAAuB;CACvB,+CAA+C;AAChD;;AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;AACnC;AACA;;;CAGC,UAAU;CACV,WAAW;AACZ;AACA;;;CAGC,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;;CAGC,yBAAyB;CACzB,mBAAmB;AACpB;AACA;CACC,sBAAsB;AACvB;;AAEA;;CAEC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV,+CAA+C;CAC/C,wCAAwC;AACzC;AACA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,wCAAwC;AACzC;AACA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,WAAW;CACX,wBAAwB;AACzB;AACA;CACC,2BAA2B;AAC5B;AACA;;;CAGC,gCAAgC;CAChC,wCAAwC;AACzC;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,gDAAgD;CAChD,mBAAmB;CACnB,4BAA4B;CAC5B,0DAA0D;AAC3D;AACA;CACC;;;;;EAKC,uBAAuB;CACxB;CACA;EACC,wBAAwB;CACzB;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,uBAAuB;CACxB;CACA;EACC,wBAAwB;CACzB;AACD;AACA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,kCAAkC;CAClC,gBAAgB;CAChB,yBAAyB;CACzB,wCAAwC;AACzC;AACA;CACC,+BAA+B;CAC/B,uBAAuB;CACvB,uDAAuD;AACxD;AACA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,uBAAuB;AACxB;AACA;;;CAGC,qBAAqB;AACtB;AACA;;CAEC,oBAAoB;AACrB;AACA;;;;CAIC,gCAAgC;AACjC;AACA;CACC,iCAAiC;AAClC;AACA;;;;CAIC,sBAAsB;CACtB,oCAAoC;CACpC,qBAAqB;AACtB;AACA;;;;CAIC,oCAAoC;AACrC;AACA;;;;;;;;;;;;CAYC,oCAAoC;AACrC;AACA;;CAEC,aAAa;CACb,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,oCAAoC;CACpC,4BAA4B;CAC5B,+BAA+B;AAChC;AACA;;;;;;;;;;;;;;CAcC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,cAAc;CACd,sBAAsB;AACvB;AACA;CACC,kCAAkC;CAClC,uCAAuC;CACvC,sCAAsC;CACtC,0CAA0C;CAC1C,yCAAyC;CACzC,kDAAkD;CAClD,sBAAsB;AACvB;AACA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,kDAAkD;CAClD,2BAA2B;CAC3B,uCAAuC;CACvC,sCAAsC;CACtC,0CAA0C;CAC1C,yCAAyC;CACzC,wBAAwB;CACxB,iFAAiF;CACjF,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;CACC,wDAAwD;AACzD;AACA;CACC,0BAA0B;CAC1B,4BAA4B;CAC5B,yCAAyC;CACzC,wDAAwD;AACzD;;AAEA;;CAEC,+BAA+B;AAChC;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;AACzB;AACA;CACC;EACC,wBAAwB;CACzB;AACD;AACA;CACC,oCAAoC;CACpC,2BAA2B;CAC3B,gCAAgC;AACjC;AACA;CACC,sBAAsB;CACtB,8CAA8C;AAC/C;;AAEA;CACC,sBAAsB;CACtB,8CAA8C;CAC9C,iCAAiC;AAClC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;;CAElB,iCAAiC;CAIjC,aAAa;CAIb,uBAAuB;CAIvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,qBAAqB;CACrB,2BAA2B;CAC3B,8CAA8C;CAC9C,uCAAuC;AACxC;;AAEA;CACC,WAAW;CACX,oCAAoC;CACpC,8BAA8B;AAC/B;AACA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,iCAAiC;AAClC;AACA;;CAEC,2BAA2B;CAC3B,qBAAqB;CACrB,sBAAsB;AACvB;AACA;;CAEC,2BAA2B;CAC3B,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,6CAA6C;CAC7C,gBAAgB;CAChB,yBAAyB;AAC1B;AACA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,6CAA6C;CAC7C,gBAAgB;CAChB,sBAAsB;AACvB;AACA;;;GAGG;AACH;;CAEC,UAAU;CACV,8BAA8B;AAC/B;AACA;;CAEC,UAAU;CACV,mBAAmB;CACnB,eAAe;CACf,yBAAyB;CAGzB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,UAAU;AACX;AACA;CACC,YAAY,EAAE,yCAAyC;CACvD,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,sBAAsB;CACtB,YAAY;CACZ,kBAAkB;CAClB,sDAAsD;AACvD;AACA;CACC,gCAAgC;AACjC;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,iCAAiC;CACjC,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,2BAA2B;CAC3B,mCAAmC;CACnC,yBAAyB;AAC1B;AACA;;;;IAII;AACJ;CACC,+CAA+C;CAC/C,kDAAkD;CAClD,iDAAiD;AAClD;AACA;CACC,8BAA8B;CAC9B,iDAAiD;CACjD,gDAAgD;AACjD;AACA;CACC,8CAA8C;CAC9C,uDAAuD;CACvD,gDAAgD;AACjD;AACA;CACC,6CAA6C;CAC7C,gDAAgD;CAChD,+CAA+C;AAChD;AACA;CACC,2BAA2B;CAC3B,8BAA8B;CAC9B,6BAA6B;CAC7B,0BAA0B;CAC1B,qBAAqB;CACrB,4CAA4C;CAC5C,qBAAqB;CACrB,uBAAuB;CACvB,sBAAsB;CACtB,8BAA8B;CAC9B,2BAA2B;CAC3B,6BAA6B;CAC7B,yBAAyB;CACzB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,oBAAoB;CACpB,uCAAuC;AACxC;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;AACrC;AACA;CACC,uBAAuB;AACxB;AACA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600&family=Poppins:wght@100;200;300;400;500;600&family=Roboto:wght@100;300;400;500&display=swap\");\nhtml {\n\tscroll-behavior: smooth;\n\tscroll-padding-top: var(--scroll-padding, 50px);\n}\n\nbody {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n\toverflow: hidden;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar,\n.design-scrollbar::-webkit-scrollbar,\n.facebook-share-window .ck.ck-content::-webkit-scrollbar {\n\twidth: 5px;\n\theight: 5px;\n}\n.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar-track,\n.design-scrollbar::-webkit-scrollbar-track,\n.facebook-share-window .ck.ck-content::-webkit-scrollbar-track {\n\tbackground-color: #fff;\n\tborder-radius: 50px;\n\tmargin-block: 10px;\n}\n.pro-sidebar .pro-sidebar-layout::-webkit-scrollbar-thumb,\n.design-scrollbar::-webkit-scrollbar-thumb,\n.facebook-share-window .ck.ck-content::-webkit-scrollbar-thumb {\n\tbackground-color: #1CBAA7;\n\tborder-radius: 50px;\n}\n.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {\n\tcolor: #fff !important;\n}\n\n.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover:before,\n.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item:before {\n\tcontent: \"\\f111\";\n\tfont-family: \"Font Awesome 6 Free\";\n\tfont-weight: 900;\n\tcolor: #1CBAA7;\n\tposition: absolute;\n\tleft: -8px;\n\ttext-shadow: 5px 0px 15px rgba(150, 197, 66, 1);\n\tbackground-color: transparent !important;\n}\n.pro-sidebar .pro-menu .pro-menu-item.active {\n\tcolor: #fff !important;\n\tposition: relative;\n}\n.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item > .pro-icon-wrapper .pro-icon svg {\n\tfill: #fff !important;\n\tcolor: #fff !important;\n}\n.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover > .pro-icon-wrapper .pro-icon svg {\n\tcolor: #fff !important;\n\tfill: #fff !important;\n}\n.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {\n\tbackground-color: transparent !important;\n}\n.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {\n\tpadding: 0 !important;\n}\n\n.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-menu-item .pro-inner-item:hover:before,\n.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-menu-item.active .pro-inner-item:before {\n\tcontent: \"\";\n\tdisplay: none !important;\n}\n#search-dropdown div input:focus {\n\tbox-shadow: none !important;\n}\ninput:focus,\nselect:focus,\ntextarea:focus {\n\tborder-color: #1CBAA7 !important;\n\tbox-shadow: 0 0 0 1px #1CBAA7 !important;\n}\ninput,\nselect,\ntextarea {\n\tcolor: #606060 !important;\n}\n.animate_notification_bell {\n\tanimation: notification_bell_animation 2s normal;\n\tanimation-delay: 2s;\n\tanimation-iteration-count: 3;\n\tanimation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);\n}\n@keyframes notification_bell_animation {\n\t0%,\n\t30%,\n\t50%,\n\t70%,\n\t100% {\n\t\ttransform: rotate(0deg);\n\t}\n\t10% {\n\t\ttransform: rotate(10deg);\n\t}\n\t40% {\n\t\ttransform: rotate(-10deg);\n\t}\n\t60% {\n\t\ttransform: rotate(5deg);\n\t}\n\t80% {\n\t\ttransform: rotate(-5deg);\n\t}\n}\n.clear-date-btn::after {\n\tcontent: \"\\f057\" !important;\n\tfont-size: 1rem !important;\n\tfont-family: \"Font Awesome 6 Free\";\n\tfont-weight: 900;\n\tcolor: #1CBAA7 !important;\n\tbackground-color: transparent !important;\n}\n.react-datepicker {\n\tfont-family: inherit !important;\n\tborder: none !important;\n\tbox-shadow: 0px 5px 15px 10px rgba(187, 193, 200, 0.25);\n}\n.react-datepicker .react-datepicker__header {\n\tbackground-color: #1CBAA7;\n\tcolor: #093653 !important;\n\tpadding: 15px 0px 5px 0px;\n}\n.react-datepicker .react-datepicker__triangle {\n\tborder: none !important;\n}\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n\tmargin: 25px 0 15px 0;\n}\n.react-datepicker__navigation--next,\n.react-datepicker__navigation--previous {\n\ttop: 15px !important;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker__navigation-icon::before {\n\tborder-color: #093653 !important;\n}\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before {\n\tborder-top-color: #fff !important;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n\tcolor: #fff !important;\n\tbackground-color: #1CBAA7 !important;\n\tborder-radius: 0.3rem;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {\n\tbackground-color: #999999 !important;\n}\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n\tbackground-color: #093653 !important;\n}\n.react-datepicker__header__dropdown,\n.react-datepicker__header__dropdown--scroll {\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n}\n\n.ql-toolbar.ql-snow {\n\tbackground-color: #1CBAA7;\n\tcolor: #fff;\n\tborder-color: transparent !important;\n\tborder-radius: 10px 10px 0 0;\n\tfont-family: inherit !important;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n\tcolor: #093653 !important;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n\tcolor: #093653 !important;\n}\n.ql-container.ql-snow {\n\tborder-color: #c6c6c6 !important;\n\tborder-radius: 0 0 10px 10px;\n\toverflow: auto;\n\twidth: 100% !important;\n}\n.ck.ck-toolbar {\n\tbackground: transparent !important;\n\tborder-top-right-radius: 6px !important;\n\tborder-top-left-radius: 6px !important;\n\tborder-bottom-right-radius: 0px !important;\n\tborder-bottom-left-radius: 0px !important;\n\tborder: 1px solid rgba(30, 30, 30, 0.3) !important;\n\twidth: 100% !important;\n}\n.ck.ck-content {\n\tbackground: #ffffff !important;\n\tcolor: #093653 !important;\n\tborder: 1px solid rgba(30, 30, 30, 0.3) !important;\n\tborder-top: none !important;\n\tborder-top-right-radius: 0px !important;\n\tborder-top-left-radius: 0px !important;\n\tborder-bottom-right-radius: 6px !important;\n\tborder-bottom-left-radius: 6px !important;\n\tmargin-top: 0 !important;\n\ttransition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n\tpadding-left: 2rem !important;\n\tpadding-right: 2rem !important;\n}\n.ck.ck-content:hover {\n\tborder-color: 1px solid rgba(30, 30, 30, 0.3) !important;\n}\n.ck.ck-content:focus {\n\toutline: 0 none !important;\n\toutline-offset: 0 !important;\n\tbox-shadow: 0 0 0 0rem #093653 !important;\n\tborder-color: 1px solid rgba(30, 30, 30, 0.3) !important;\n}\n\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\tfont-family: inherit !important;\n}\n.ck.ck-editor__editable_inline {\n\tbox-shadow: none !important;\n}\n\n.facebook-share-window .ck.ck-content {\n\theight: 240px !important;\n}\n@media (min-width: 1559px) {\n\t.facebook-share-window .ck.ck-content {\n\t\theight: 275px !important;\n\t}\n}\nbutton.custom-btn {\n\ttext-transform: uppercase !important;\n\tfont-weight: 400 !important;\n\tletter-spacing: 0.5px !important;\n}\ninput.custom-input {\n\tcolor: #000 !important;\n\tborder-color: rgba(30, 30, 30, 0.3) !important;\n}\n\ninput.custom-phone-input {\n\tcolor: #000 !important;\n\tborder-color: rgba(30, 30, 30, 0.3) !important;\n\tbackground-color: #fff !important;\n}\n\n.swiper {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.swiper-slide {\n\ttext-align: center;\n\n\t/* Center slide text vertically */\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: -webkit-flex;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\t-webkit-justify-content: center;\n\tjustify-content: center;\n\t-webkit-box-align: stretch;\n\t-ms-flex-align: stretch;\n\t-webkit-align-items: stretch;\n\talign-items: stretch;\n}\n.swiper-slide img {\n\tdisplay: block;\n\twidth: 100%;\n\t/* height: 100%; */\n\tobject-fit: contain;\n}\n\n.swiper-pagination-bullet {\n\twidth: 12px !important;\n\theight: 12px !important;\n\ttext-align: center;\n\topacity: 1 !important;\n\tbackground: #fff !important;\n\tbackground: rgba(107, 168, 2, 0.25) !important;\n\tborder: 1px solid rgba(149, 197, 66, 1);\n}\n\n.swiper-pagination-bullet-active {\n\tcolor: #fff;\n\tborder: 1px solid #1CBAA7 !important;\n\tbackground: #1CBAA7 !important;\n}\n.swiper-button-next,\n.swiper-button-prev {\n\tbottom: 0 !important;\n\ttop: 95% !important;\n\theight: 30px !important;\n\twidth: 30px !important;\n\tpadding: 5px !important;\n}\n.swiper-button-next {\n\tbackground-color: #1CBAA7 !important;\n}\n.swiper-button-prev {\n\tbackground-color: #fff !important;\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n\t/* right: 53% !important; */\n\tright: 13% !important;\n\tleft: unset !important;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n\t/* right: 47% !important; */\n\tright: 5% !important;\n\tleft: unset !important;\n}\n.swiper-button-prev:after {\n\tcontent: \"\\f060\" !important;\n\tfont-size: 1rem !important;\n\tfont-family: \"Font Awesome 6 Free\" !important;\n\tfont-weight: 900;\n\tcolor: #1CBAA7 !important;\n}\n.swiper-button-next:after {\n\tcontent: \"\\f061\" !important;\n\tfont-size: 1rem !important;\n\tfont-family: \"Font Awesome 6 Free\" !important;\n\tfont-weight: 900;\n\tcolor: #fff !important;\n}\n/* .swiper-button-next.swiper-button-disabled,\n.swiper-button-prev.swiper-button-disabled {\n\tdisplay: none !important;\n} */\n.donation-level .hover-btn,\n.rt-tbody .rt-tr-group .hover-btn {\n\topacity: 0;\n\ttransition: all 0.15s ease-out;\n}\n.donation-level:hover .hover-btn,\n.rt-tbody .rt-tr-group:hover .hover-btn {\n\topacity: 1;\n\tvisibility: visible;\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\ninput[type=\"color\"] {\n\twidth: 48px;\n\theight: 48px;\n\tborder: none;\n\tborder-radius: 50%;\n\tbackground: none;\n}\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n\tpadding: 0;\n}\ninput[type=\"color\"]::-webkit-color-swatch {\n\tborder: none; /*change color of the swatch border here*/\n\tborder-radius: 50%;\n\tcursor: pointer;\n}\n.filter-dropdown {\n\twidth: 300px;\n\tmin-width: 250px;\n\tbackground-color: #fff;\n\tborder: none;\n\tborder-radius: 5px;\n\tbox-shadow: 0px 5px 15px 10px rgba(187, 193, 200, 0.1);\n}\n.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {\n\twhite-space: pre-wrap !important;\n}\n.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {\n\tpadding-left: 50px !important;\n}\ninput::placeholder {\n\tfont-size: 16px !important;\n}\n.react-datepicker-popper {\n\tz-index: 10 !important;\n}\n.error-msg {\n\tcolor: #df5151 !important;\n}\n.custom-toast {\n\tfont-family: \"Roboto\", sans-serif;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n}\n.toast-glass-effect {\n\tbackdrop-filter: blur(15px);\n\t-webkit-backdrop-filter: blur(15px);\n\t/* border-radius: 10px; */\n}\n/* .Toastify__toast-theme--colored.Toastify__toast--default {\n\tbackground: rgba(255, 255, 255, 0.45) !important;\n\tbox-shadow: 0 8px 32px 0 rgba(255, 255, 255, 0.15);\n\tborder: 1px solid rgba(255, 255, 255, 0.25);\n } */\n.Toastify__toast-theme--colored.Toastify__toast--info {\n\tbackground: rgba(190, 227, 248, 0.5) !important;\n\tbox-shadow: 0 8px 32px 0 rgba(190, 227, 248, 0.15);\n\t/* border: 1px solid rgba(190, 227, 248, 0.25); */\n}\n.Toastify__toast-theme--colored.Toastify__toast--success {\n\tbackground: #1CBAA7 !important;\n\tbox-shadow: 0 8px 32px 0 rgba(150, 197, 66, 0.15);\n\t/* border: 1px solid rgba(150, 197, 66, 0.25); */\n}\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n\tbackground: rgba(241, 196, 15, 0.5) !important;\n\t/* box-shadow: 0 8px 32px 0 rgba(241, 196, 15, 0.15); */\n\t/* border: 1px solid rgba(241, 196, 15, 0.25); */\n}\n.Toastify__toast-theme--colored.Toastify__toast--error {\n\tbackground: rgba(221, 57, 57, 0.5) !important;\n\tbox-shadow: 0 8px 32px 0 rgba(221, 57, 57, 0.15);\n\t/* border: 1px solid rgba(221, 57, 57, 0.25); */\n}\n.react-datepicker__navigation--years {\n\tbackground: none !important;\n\tline-height: 1.7rem !important;\n\ttext-align: center !important;\n\tcursor: pointer !important;\n\tpadding: 0 !important;\n\tborder: 0.45rem solid transparent !important;\n\tz-index: 1 !important;\n\theight: 10px !important;\n\twidth: 10px !important;\n\ttext-indent: -999em !important;\n\toverflow: hidden !important;\n\tposition: relative !important;\n\tdisplay: block !important;\n\tmargin-left: auto !important;\n\tmargin-right: auto !important;\n}\n\n.react-datepicker__navigation--years.react-datepicker__navigation--years-upcoming {\n\ttop: -2px !important;\n\tborder-bottom-color: #093653 !important;\n}\n\n.react-datepicker__navigation--years.react-datepicker__navigation--years-previous {\n\ttop: 8px !important;\n\tborder-top-color: #093653 !important;\n}\n.react-datepicker__year-option {\n\theight: 20px !important;\n}\n.text-overflow {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
